import "./AndarBaharPL.scss";
import React, { useEffect, useState } from 'react'

const AndarBaharPL = ({roundMarkets}) => {
 let [winnerData, setWinnerData] = useState(null);

 const getWinner = () => {
   let winObj = {};
   if (roundMarkets.length > 0) {
     roundMarkets.forEach((market) => {
       market.marketRunner.forEach((runner) => {
         if (runner.status === 'WINNER') {
           winObj[market.marketHeader] = runner.name;
         }
       });
     });
   }
   setWinnerData(winObj)
  }
  useEffect(() => {
    getWinner()
  }, [roundMarkets]);

  const cardSrc = (card) => {
    if (card) {
      return `https://stream.fawk.app/assets/smallCards/${card}.png`;
    } else {
      return "https://stream.fawk.app/assets/smallCards/BACK.png";
    }
  };

    return (
      <div className="andar-bahar-betting">
        <div className="andar-bahar-betting__games">
          <div className="andar-bahar-betting__games-item">
            <span
              className={`andar-bahar-betting__games-item-title ${roundMarkets[0].marketRunner[1].status === 'WINNER' ? 'winnerCup':''}`}>
                Andar
           </span>
            <div className="andar-bahar-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[1].cards.map(card => <img className="andar-bahar-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
          <div className="andar-bahar-betting__games-item">
            <span
              className={`andar-bahar-betting__games-item-title ${roundMarkets[0].marketRunner[0].status === 'WINNER' ? 'winnerCup':''}`}>
                Bahar
            </span>
            <div className="andar-bahar-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[0].cards.map(card => <img className="andar-bahar-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
          <div className="andar-bahar-betting__games-item andar-bahar-betting__games-item-joker">
          <span
            className={`andar-bahar-betting__games-item-title ${(roundMarkets[0].marketRunner[0].status !== 'WINNER' && roundMarkets[0].marketRunner[1].status !== 'WINNER') ? 'winnerCup':''}`}>
            Joker
          </span>
            <div className="andar-bahar-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].indexCard.map(card => <img className="andar-bahar-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
        </div>
        <div className="andar-bahar-betting__info-column">
          <div className="andar-bahar-betting__info-row">
            <div className="andar-bahar-betting__info-row-title">
              <span>Winner:</span>
            </div>
            <div className="andar-bahar-betting__info-row-results">
              <span>{winnerData && winnerData['1st Card Bahar 25%']  || 'No Winner' }</span>
            </div>
          </div>
        </div>
      </div>
    );
};

export default AndarBaharPL;

